import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PagesModule } from "@root/router/pages.module";
import { PreloadingStrategyService } from "./preloading-strategy";
const routes: Routes = [
  {
    path: "app",
    children: [
      //#region 外部页面 - h5页面
      {
        path: "h5",
        children: [
          {
            path: "check-in-guide",
            loadChildren: () =>
              import("@root/router/public/h5/check-in-guide/check-in-guide.module").then((m) => m.CheckInGuideModule),
          },
          {
            path: "cleaner",
            loadChildren: () => import("@root/router/public/h5/cleaner/cleaner.module").then((m) => m.CleanerModule),
          },
          {
            path: "channel",
            loadChildren: () => import("@root/router/public/h5/channel/channel.module").then((m) => m.ChannelModule),
          },
        ],
      },
      //#endregion
      {
        path: "share",
        children: [
          {
            path: "calendar",
            loadChildren: () =>
              import("@root/router/public/calendar/calendar.module").then((m) => m.PublicCalendarModule),
          },
        ],
      },

      { path: "**", loadChildren: () => import("@root/router/error/error.module").then((m) => m.ErrorModule) },
      //#endregion
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [
    PagesModule,
    RouterModule.forRoot(routes, {
      enableTracing: false,
      preloadingStrategy: PreloadingStrategyService,
      bindToComponentInputs: true,
    }),
  ],
  // imports: [HostRouterModule],
  exports: [RouterModule],
  // providers: [
  //   { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy }
  // ]
})
export class AppPublicRouteModule {}
